import { combineReducers } from 'redux'
import _ from 'lodash'

import * as healthPhysicianReviewsList from './list'
import * as getHealthPhysicianReview from './get'
import * as createHealthPhysicianReview from './create'
import * as editHealthPhysicianReview from './edit'
import * as deleteHealthPhysicianReview from './delete'

const slices = {
  healthPhysicianReviewsList,
  getHealthPhysicianReview,
  createHealthPhysicianReview,
  editHealthPhysicianReview,
  deleteHealthPhysicianReview
}

const healthPhysicianReviewTypes = _.mapValues(slices, (s) => s.slice.types)
const healthPhysicianReviewActions = Object.assign({}, ..._(slices).values().map('slice.actions').value())
const healthPhysicianReviewSagas = _(slices).values().map('slice.sagas').flatten().value()
const healthPhysicianReviewSelectors = Object.assign({}, ..._(slices).values().map('slice.selectors').value())
const reducers = Object.assign({}, ..._(slices).values().map('default').value())

export { healthPhysicianReviewTypes, healthPhysicianReviewActions, healthPhysicianReviewSagas, healthPhysicianReviewSelectors }

export default combineReducers(reducers)
